export default "__VITE_ASSET__Dgr6W20J__"